// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"76":"common","823":"investor","933":"auth","938":"entrepreneur"}[chunkId] + "." + {"76":"a084dffc","823":"faf69671","933":"39c0e9bc","938":"9b5d51d7"}[chunkId] + ".css";
};